import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['list', 'variant'];

  connect() {
    this.onShow = (event) => this.open(event.relatedTarget);
    this.onHidden = () => this.close();
    this.element.addEventListener('show.bs.offcanvas', this.onShow);
    this.element.addEventListener('hidden.bs.offcanvas', this.onHidden);
  }

  disconnect() {
    this.close();
    this.element.removeEventListener('show.bs.offcanvas', this.onShow);
    this.element.removeEventListener('hidden.bs.offcanvas', this.onHidden);
  }

  open(trigger) {
    this.card = trigger.closest('.card-product');
    this.card?.classList.add('wishlist-selector-card-offcanvas-open');
    this.variantTarget.value = trigger.dataset.variantId;
    this.listTarget.src = `/wishlists/selector?variant_id=${trigger.dataset.variantId}`;
  }

  close() {
    this.card?.classList.remove('wishlist-selector-card-offcanvas-open');
    this.card = null;
  }
}
